interface IConfig {
  feature_flag: Record<string, boolean>;
}

declare const CONFIG: IConfig;

export const FEATURE_FLAG = CONFIG.feature_flag || {};
